<h2 class="secondary" data-bb="sign-title">{{ 'mijn.omgeving.sign.title' | apContent }}</h2>

<ap-sign
    [actionId]="signOptions.actionId"
    [submitText]="'mijn.omgeving.sign.submit' | apContent"
    [cancelText]="'mijn.omgeving.sign.cancel' | apContent"
    (done)="doneSigning()"
    (retry)="onRetry()"
    (canceled)="navigateBack()"
>
</ap-sign>
